import styled from 'styled-components'

export const ModalHeader = styled.div<{ color: string }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    background: ${({ color }) => color};
    height: 44px;
    font-size: 21px;
    font-family: ${({ theme }) => theme['font-bold']};
    color: #fff;

    > .bowtie-modal-icons {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 15px;
    }
`

export const ModalContent = styled.div`
    color: ${({ theme }) => theme['gray-1000']};
    padding: 15px;

    > .bowtie-modal-barrier-name {
        padding: 15px 0;
        font-size: 21px;
        font-family: ${({ theme }) => theme['font-bold']};
    }

    > .bowtie-modal-barrier-details {
        font-size: 18px;
        margin-top: 2px;
        font-family: ${({ theme }) => theme['font-regular']};
        /* .mandatory-icon {
            transform: scale(1.8) !important;
        } */
        &.mandatory-icon {
            display: flex;
            align-items: center;
            gap: 8px;
        }
    }

    > .bowtie-modal-barrier-degradation {
        font-size: 18px;
        margin-bottom: 10px;
        font-family: ${({ theme }) => theme['font-regular']};
    }

    > .bowtie-modal-barrier-evidences {
        font-size: 18px;
        margin-bottom: 10px;
        font-family: ${({ theme }) => theme['font-regular']};
    }
`
